<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h4 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">金刚经6大名句</h4>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       读《金刚经》帮助我们开悟，许多学佛者都知道。我国禅宗六祖惠能大师自幼就甚爱诵读《金刚经》，行住坐卧，时时处处不忘。他因彻底了通悟透该经中的“应无所住而生其心”，而明心见性、开悟成佛。
       该经和《般若波罗蜜多心经》一样，被奉为大乘佛教经典的教义，是开般若智慧的无上法宝。本篇文章，小编就该经中比较经典的6句话分享解析给大家，望大家能从中受益。南无本师释迦牟尼佛。
       

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      一、须菩提，菩萨于法，应无所住，行于布施。所谓不住色布施，不住声、香、味、触、法布施。菩萨了知一切诸法其性本空，为因缘聚灭会合，所以于世间所有的万事万物，都应无所执着，以此无住法中，修行布施，利益众生。
      也就是六根清净，不住色声香味触法等六尘，而去行布施。
      

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      二、以是义故，如来常说，汝等比丘，知我说法，如筏喻者，法尚应舍，何况非法因此如来常说：你们诸位比丘应当知晓，我所说的佛法，就如同那渡人到岸的舟楫，到达彼岸之后，即应弃舟登岸，不可背负不舍。
      所以，未悟道时，须依法修持，悟道后就不该执着于法，至于那偏执于非法的妄心，更是应当舍去。
      

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       三、尔时须菩提白佛言：“世尊，善男子善女人，发阿耨多罗三藐三菩提，云何应住？云何降伏其心？”佛告须菩提：“善男子善女人，发阿耨多罗三藐三菩提心者，当生如是心，我应灭度一切众生；灭度一切众生已，而无有一众生实在灭度者”。
       何以故？须菩提，若菩萨有我相、人相、众生相、寿者相，则非菩萨。须菩提向佛陀请示道：佛陀！善男子、善女人，已经发心求无上正等正觉，应该如何保持那颗菩提心？如何降伏那妄想动念的心？
       佛陀微笑颔首之后，以无上慈和的声音说道：善男子、善女人如果已经发心求无上正等正觉，应当如是发心：我应该发起无上清净心，使众生灭除一切烦恼，到达涅槃的境界，如此灭度一切众生，但不认为有一个众生是因我而灭度的。
       如果菩萨有我相、人相、众生相、寿者相等分别，那么，他就不是菩萨。
       

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       四、如来者，无所从来，亦无所去，故名如来。所谓如来者，实在是无所来处，也无所去处，所以才称为如来。因为如来就是法身，法身无形无相，遍满虚空，无所不在，寂然不动，哪里还有来去之名呢？
       众生所见的语默动静之相，不过是如来的应化之身，应化身为随众生之机缘感应有隐有现，但是法身则恒常寂静，从未有来、去、坐、卧的相状。
       

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
       五、若菩萨以满恒河沙等世界七宝，持用布施。若复有人，知一切法无我，得成于忍。此菩萨，胜前菩萨所得功德。菩萨若用满恒河沙等世界的七宝来布施，所得功德，当然无法计量。
       如果明白一切法无我，皆由因缘所生，无有真实永恒的体性，由此了知无生无灭，不为外境所动，即与空性相应。内无贪念，外无所得，亲证无生法忍，那么，这位菩萨所得的功德要比七宝布施的菩萨更多。
      
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">

       六、如来所说三千大千世界，即非世界，是名世界。如来说过，三千大千世界并非即是真实恒常的世界，也仅是一个假名而已。为什么呢？如果世界是实有的，那就是一合相。
       如来说的一合相，也非实有，缘生则聚，分合离散，仍然不是实有不变的一合相，也只是缘散即无，一个假名罢了。
      </p>
    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/fo/3.vue